import { render, staticRenderFns } from "./addVersementBanque.vue?vue&type=template&id=b5e61116&"
import script from "./addVersementBanque.vue?vue&type=script&lang=js&"
export * from "./addVersementBanque.vue?vue&type=script&lang=js&"
import style0 from "./addVersementBanque.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports